import React, { PureComponent } from 'react'
import { Grid, Paper, Table, TableHead, TableCell, TableBody, TableRow } from '@material-ui/core'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'

import {
  setCloverAccount,
  getThirdPartyAccounts,
  updateThirdPartyAccount,
  addNewThirdPartyAccount,
} from '../../../actions/thirdParty'
import { getShopList } from '../../../actions/shop'
import { connect } from 'react-redux'
import { globalValidator } from '../../../utils/validations/common'
import { hasAccess } from '../../../utils/api'
import { openErrorMessage } from '../../../actions/message'
import EditableHOCWrapper from '../../HOC/EditableHOC'
import CloverItem from '../../../components/Clover/CloverItem'

const CloverItemEditable = EditableHOCWrapper(CloverItem)

class Clover extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      clover: {},
      lastModified: null,
    }
  }

  componentDidMount() {
    this.props.dispatch(getShopList())
    //this.props.dispatch(getThirdPartyAccounts());
    this.fetchCloverAccounts()
  }

  fetchCloverAccounts = () => {
    const data = {}

    this.props.dispatch(getThirdPartyAccounts()).then((thirdPartyAccounts) => {
      const { values = [] } = thirdPartyAccounts || {}
      values &&
        values.length &&
        values
          .filter((item) => item.accountType === 'Clover')
          .forEach((item) => {
            data[item.shopId] = { ...(data[item.shopId] || {}), ...item }
          })

      this.setState({
        clover: data,
        lastModified: new Date().valueOf(),
      })
      this.props.dispatch(setCloverAccount(data))
    })
  }

  onSave = (shopId) => (data, afterSave) => {
    const keys = [
      { name: 'name', title: 'Name', validateKey: 'required' },
      { name: 'username', title: 'Username', validateKey: 'required' },
      { name: 'merchantId', title: 'Merchant Id', validateKey: 'required' },
      { name: 'token', title: 'Token', validateKey: 'required' },
    ]

    const valid = globalValidator(data, keys)

    if (valid === true) {
      if (data.id) {
        this.props.dispatch(updateThirdPartyAccount(data)).then((res) => {
          this.fetchCloverAccounts()
          afterSave && afterSave()
        })
      } else {
        this.props.dispatch(addNewThirdPartyAccount(data)).then((res) => {
          this.fetchCloverAccounts()
          afterSave && afterSave()
        })
      }
    } else {
      this.props.dispatch(openErrorMessage(valid))
    }
  }

  onCancel = () => {
    const { cloverAccounts = {} } = this.props.thirdPartyReducer
    this.setState({
      clover: cloverAccounts,
      editMode: false,
    })
  }

  render() {
    const { clover = {}, lastModified } = this.state
    const { shopsList = {} } = this.props.shopReducer

    return (
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
          <Paper>
            <div className="table-scroll cell-padd-remove">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Shop</TableCell>
                    <TableCell>Enabled</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Username</TableCell>
                    <TableCell>Merchant Id</TableCell>
                    <TableCell>Token</TableCell>
                    {hasAccess() ? <TableCell>Actions</TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {shopsList &&
                    shopsList.values &&
                    shopsList.values.length &&
                    shopsList.values.map((shop, index) => {
                      return (
                        <CloverItemEditable
                          key={index}
                          shop={shop}
                          onSave={this.onSave(shop.id)}
                          dataToEdit={clover[shop.id] || { shopId: shop.id, accountType: 'Clover' }}
                          lastModified={lastModified}
                        />
                      )
                    })}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

const CloverWithTitle = ContainerWithTitleWrapper(Clover, 'Clover Settings')

export default connect((state) => {
  return {
    dispatch: state.dispatch,
    thirdPartyReducer: state.thirdPartyReducer,
    shopReducer: state.shopReducer,
  }
})(CloverWithTitle)



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/Clover.js